module.exports = __webpack_public_path__ + "static/img/Paul-Bryan.8bf6258.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Paul-Bryan.jpg
// module id = RDAR
// module chunks = 0